// Vendor Components
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import classnames from 'classnames';

// Components
import Button from '../core/button';
import Dropdown from '../core/dropdown';
import Logout from '../core/logout';

// Redux Actions
import {resetForm} from '../../actions/form-data-actions';
import {layoutReset} from '../../actions/layout-actions';
import {resetServiceData} from '../../actions/services-data-actions';

// Styles
import './logged-in-dropdown.scss';

function LoggedInDropdown({className, layoutReset, resetForm, username}) {
    const getDropdownProps = () => ({
        buttonClassName: 'logged-in-dropdown--button',
        className: classnames('logged-in-dropdown', className),
        dropdownRenderer: renderDropdownItems,
        type: 'link',
    });

    const handleResetLayoutClick = (event) => {
        event && event.preventDefault && event.preventDefault();

        layoutReset();
    };

    const handleResetSearchClick = (event) => {
        event && event.preventDefault && event.preventDefault();

        resetForm(null, true, true);
    };

    const renderDropdownItems = () => (
        <ul>
            <li>
                <Link to="/change-password">Change Password</Link>
            </li>
            <li>
                <Button type="link" onClick={handleResetLayoutClick}>
                    Reset Layout
                </Button>
            </li>
            <li>
                <Button type="link" onClick={handleResetSearchClick}>
                    Reset Search
                </Button>
            </li>
            <li>
                <Logout buttonType="link" />
            </li>
        </ul>
    );

    return username ? <Dropdown {...getDropdownProps()}>logged in as {username}</Dropdown> : null;
}

LoggedInDropdown.propTypes = {
    className: PropTypes.string,
    layoutReset: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    resetServiceData: PropTypes.func.isRequired,
    username: PropTypes.string,
};

const mapStateToProps = (state) => ({
    username: state.auth.user,
});

const mapDispatchToProps = {layoutReset, resetForm, resetServiceData};

export default connect(mapStateToProps, mapDispatchToProps)(LoggedInDropdown);
